/* src/app/modules/home/pages/user-help-page/user-help-page.component.scss */
.help-card {
  border-radius: 16px;
  cursor: pointer;
}
.help-card:hover .card-image {
  transform: scale(1.05);
}
.card-image-container {
  position: relative;
  height: 200px;
  overflow: hidden;
  background:
    linear-gradient(
      135deg,
      var(--ion-color-light) 0%,
      var(--ion-color-light-shade) 100%);
}
.card-overlay {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
}
.card-gradient {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  background:
    linear-gradient(
      to top,
      rgba(0, 0, 0, 0.4),
      transparent);
  opacity: 0.6;
  transition: opacity 0.3s ease;
  pointer-events: none;
}
.pinned-icon {
  font-size: 1.5rem;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  padding: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  zoom: 1.5;
}
.custom-card-header {
  background:
    linear-gradient(
      90deg,
      var(--ion-color-primary),
      var(--ion-color-secondary));
  border-radius: 12px 12px 0 0;
  margin-bottom: 0.5em;
}
.custom-card-title {
  letter-spacing: 0.5px;
  text-align: center;
  text-transform: uppercase;
}
.custom-card-content {
  padding: 1.2em 1em 1em 1em;
}
.description-ellipsis {
  text-align: center;
  max-height: 3.6em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.2s;
}
.description-ellipsis:hover {
  background: rgba(0, 0, 0, 0.04);
}
.card-footer {
  display: flex;
  justify-content: center;
  padding: 0.7em;
}
.card-footer ion-button {
  text-overflow: ellipsis;
  --background: var(--ion-color-primary);
  color: var(--ion-color-primary-contrast);
}
.card-footer-empty {
  height: 2.5em;
}
@media only screen and (max-width: 720px) {
  ion-card {
    zoom: 0.8 !important;
  }
}
.dashboard-return-footer {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 32px;
  padding: 0 8px;
}
.dashboard-footer-line {
  flex: 1;
  height: 3px;
  background-color: var(--ion-color-medium, #92949c);
  opacity: 0.4;
}
.dashboard-return-btn {
  --border-radius: 8px;
  font-weight: 600;
  font-size: 1rem;
  min-width: 160px;
}
/*# sourceMappingURL=user-help-page.component-RCY6YGND.css.map */
